import CommitStatusDone from '../components/CommitStatus/CommitStatusDone';
import CommitStatusFailed from '../components/CommitStatus/CommitStatusFailed';
import CommitStatusProcessing from '../components/CommitStatus/CommitStatusProcessing';
import CommitStatusTimedOut from '../components/CommitStatus/CommitStatusTimedOut';
import { COMMIT_STATUS } from '../constants/api';
export default class CommitStatusFactory {
    static createInstance(commit) {
        const commitStatus = commit.status;
        if (commitStatus === COMMIT_STATUS.DONE) {
            return new CommitStatusDone();
        }
        else if (commitStatus === COMMIT_STATUS.FAIL) {
            return new CommitStatusFailed();
        }
        else if (commit.isTimedOut()) {
            return new CommitStatusTimedOut();
        }
        return new CommitStatusProcessing();
    }
}
